import React, { useContext, useEffect } from "react";
import { format } from "date-fns";
import "./styles.css";

import { ResumeContext } from "../../../contexts/resumeContext";

function Apex({ info }) {
  const { setColorOptions, activeColor, setActiveColor, resumeHeadings, setImgSupported } =
    useContext(ResumeContext);

  useEffect(() => {
    setColorOptions(["#000"]);
    setActiveColor("#000");
    setImgSupported(false)
  }, []);

  const {
    personalDetails,
    educationDetails,
    professionalDetails,
    skills,
    social,
    misc,
  } = info;

  const education = Object.values(educationDetails || {});
  const work = Object.values(professionalDetails || {});
  const userSkills = Object.values(skills || {});
  const socialLinks = Object.values(social || {});

  const { courses, hobbies, languages, references, internships, activities, projects } =
    misc || {};

  return (
    <div className="apex">
      <div className="apex__header">
          <h1 className="apex__title">
            {personalDetails?.firstName?.trim()}{" "}
            {personalDetails?.lastName?.trim()}
          </h1>
          <p className="apex__jobTitle">{personalDetails?.jobTitle}</p>
          <ul className={"apex__contactList"}>
            {personalDetails?.phone && (
              <li>
                <a href={`tel:${personalDetails?.phone?.trim()}`}>
                  {personalDetails?.phone?.trim()}
                </a>
              </li>
            )}
            {personalDetails?.email && (
              <li>
                <a href={`mailto:${personalDetails?.email?.trim()}`}>
                  {personalDetails?.email?.trim()}
                </a>
              </li>
            )}
            {(personalDetails?.address?.trim() ||
              personalDetails?.postalCode?.trim()) && (
              <li>
                {personalDetails?.address?.trim()}
                {personalDetails?.postalCode?.trim() && " - "}
                {personalDetails?.postalCode?.trim()}
              </li>
            )}
            {socialLinks.map((link, ix) =>
              link.link !== "" ? (
                <li>
                  <a href={link.link} target="_blank">
                    {link.link}
                  </a>
                </li>
              ) : null
            )}
          </ul>
      </div>
      <div className="apex__body">
            {personalDetails?.summary && <div className="apex__section">
                <h3 className="apex__section__heading">
                  {resumeHeadings?.SUM}
                </h3>
                <div className="apex__section__content">
                <p
                    dangerouslySetInnerHTML={{ __html: personalDetails?.summary }}
                />
                </div>
            </div>}
            {!!userSkills?.length && <div className="apex__section">
              <h3 className="apex__section__heading">
              {resumeHeadings?.SK}
              </h3>
              <ul className="apex__skills__list">
                {userSkills.map((skill, ix) => (
                  <li key={skill + ix}>{skill}</li>
                ))}
              </ul>
            </div>}
            {!!work?.length && <div className="apex__section">
              <h3 className="apex__section__heading">
              {resumeHeadings?.WE}
              </h3>
              {work.map((exp, ix) => (
                <div className="apex__subsection" key={`exp_${ix}`}>
                  <strong>
                    {exp.jobTitle}
                  </strong>
                  <p className="apex__subsection_text">
                    <strong>
                        {exp.company}{exp.location && <>, {exp.location}</>}
                        <span style={{ float: "right"}}>
                        {exp.startDate && (
                            <>{format(new Date(exp.startDate), "MMM yyyy")}</>
                        )}{" "}
                        {exp.endDate && (
                           <>- {exp.endDate === "Present" ? "Present" : format(new Date(exp.endDate), "MMM yyyy")}</>
                        )}
                        </span>
                    </strong>
                  </p>
                  <div
                    className="apex__subsection_text"
                    dangerouslySetInnerHTML={{ __html: exp.description }}
                  />
                </div>
              ))}
            </div>}
            {!!internships?.length && (
              <div className="apex__section">
                <h3 className="apex__section__heading">
                  {resumeHeadings?.INT}
                </h3>
                {internships.map((intern, ix) => (
                  <div className={"apex__subsection"} key={`intern_${ix}`}>
                    <p style={{ marginBottom: 0 }}>
                      <strong>{intern.jobTitle}</strong>
                      <strong style={{ float: "right" }}>
                        {intern.startDate && (
                          <>{format(new Date(intern.startDate), "MMM yyyy")}</>
                        )}{" "}
                        {intern.endDate && (
                          <>- {format(new Date(intern.endDate), "MMM yyyy")}</>
                        )}
                      </strong>
                    </p>
                    <p className={"apex__subsection_text"}>
                      <strong>{intern.company}{intern.location && <>, {intern.location}</>}</strong>
                    </p>
                    <div
                      className={"apex__subsection_text"}
                      dangerouslySetInnerHTML={{ __html: intern.description }}
                    />
                  </div>
                ))}
              </div>
            )}
            {!!education?.length && <div className="apex__section">
              <h3 className="apex__section__heading">
              {resumeHeadings?.AD}
              </h3>
              {education?.map((ed, ix) => (
                <div className={"apex__subsection"} key={`ed_${ix}`}>
                  <strong>{ed.degree}</strong>
                  <p className={"apex__subsection_text"}>
                      {ed.institute}{ed.location && <>, {ed.location}</>}
                        <span style={{float:'right'}}>
                            {ed.startDate && (
                            <>{format(new Date(ed.startDate), "MMM yyyy")}</>
                            )}{" "}
                            {ed.endDate && (
                            <>- {format(new Date(ed.endDate), "MMM yyyy")}</>
                            )}
                        </span>
                  </p>
                  <div
                    className={"apex__subsection_text"}
                    dangerouslySetInnerHTML={{ __html: ed.description }}
                  />
                </div>
              ))}
            </div>}
            {!!projects?.length && <div className="apex__section">
              <h3 className="apex__section__heading">
                {resumeHeadings?.PRO}
              </h3>
              {projects?.map((pro, ix) => (
                <div className={"apex__subsection"} key={`pro_${ix}`}>
                  <strong>{pro.title}</strong>
                  <p className={"apex__subsection_text"}>
                      {pro.company}
                        <span style={{float:'right'}}>
                            {pro.startDate && (
                            <>{format(new Date(pro.startDate), "MMM yyyy")}</>
                            )}{" "}
                            {pro.endDate && (
                            <>- {format(new Date(pro.endDate), "MMM yyyy")}</>
                            )}
                        </span>
                  </p>
                  <div
                    className={"apex__subsection_text"}
                    dangerouslySetInnerHTML={{ __html: pro.description }}
                  />
                </div>
              ))}
            </div>}
            {!!courses?.length && (
              <div className={"apex__section"}>
                <h3 className="apex__section__heading">
                  {resumeHeadings?.CR}
                </h3>
                {courses?.map((course, ix) => (
                  <div className={"apex__subsection"} key={`course_${ix}`}>
                    <strong>{course.name}</strong>
                    <p className={"apex__subsection_text"}>
                      {course.institution}{" "}
                      <span style={{ float: "right" }}>
                        {course.startDate && (
                          <>{format(new Date(course.startDate), "MMM yyyy")}</>
                        )}{" "}
                        {course.endDate && (
                          <>- {format(new Date(course.endDate), "MMM yyyy")}</>
                        )}
                      </span>
                    </p>
                  </div>
                ))}
              </div>
            )}
            {!!activities?.length && (
              <div className="apex__section">
                <h3 className="apex__section__heading">
                  {resumeHeadings?.ACT}
                </h3>
                {activities.map((activity, ix) => (
                  <div className={"apex__subsection"} key={`activity_${ix}`}>
                    <strong>
                      {activity.title}
                    </strong>
                    <p className={"apex__subsection_text"}>
                      {activity.institution}
                      <span style={{ float: "right" }}>
                        {activity.startDate && (
                          <>
                            {format(new Date(activity.startDate), "MMM yyyy")}
                          </>
                        )}{" "}
                        {activity.endDate && (
                          <>
                            - {format(new Date(activity.endDate), "MMM yyyy")}
                          </>
                        )}
                      </span>
                    </p>
                    <div
                      className={"apex__subsection_text"}
                      dangerouslySetInnerHTML={{ __html: activity.description }}
                    />
                  </div>
                ))}
              </div>
            )}
            {!!hobbies?.length && (
              <div className="apex__section">
                <h3 className="apex__section__heading">
                  {resumeHeadings?.HOB}
                </h3>
                <p className={"apex__subsection_text"}>{hobbies}</p>
              </div>
            )}
            {!!languages?.length && (
              <div className="apex__section">
                <h3 className="apex__section__heading">
                  {resumeHeadings?.LAN}
                </h3>
                <p className={"apex__subsection_text"}>{languages}</p>
              </div>
            )}
            {!!references?.length && (
              <div className="apex__section">
                <h3 className="apex__section__heading">
                  {resumeHeadings?.REF}
                </h3>
                {references?.map((ref, ix) => (
                  <div className="apex__subsection" key={`ref_${ix}`}>
                    <strong>
                      {ref.name}{" "}
                      {ref.institution && <>from {ref.institution}</>}
                    </strong>
                    <p className="apex__subsection_text">
                      {ref.email}{" "}
                      {ref.phone && <> &nbsp; | &nbsp; {ref.phone}</>}
                    </p>
                  </div>
                ))}
              </div>
            )}
      </div>
    </div>
  );
}

export default Apex;
